import { comboboxOption } from "../../Components/InvoiceEditor/constants";
import ApiConfig from "../../Utils/Configs/apiConfig";

export const getAllSuppliersApi = async () => {
  try {
    const response = await ApiConfig.getInstance().get("/Supplier/get-all", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
   
  } catch (error: any) {
    console.error("Error fetching suppliers:", error);
    throw error.response?.data || error.message;
  }
};

export const addSupplierApi = async (names: string[]) => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/Supplier/add",
      {
        names: names,
      },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
        },
      }
    );
if(response.data?.data?.supplierId === null && response.data?.data?.name === null) {
  throw new Error("API did not return valid supplier data");
} 
  return { optionId: response.data.data[0].supplierId, optionName: response.data.data[0].name };
  } catch (error: any) {
    console.error("Error adding supplier:", error);
    throw error.response?.data || error.message;
  }
};